import { Swiper, SwiperSlide } from "swiper/react";
import { useRecoilValue } from "recoil";
import { insetState } from "../../../../../recoil/inset";
import { areaList } from "../../type/area";
import { FranchiseAreaFilterWrapper, CardItemWrapper } from "./styles";

interface FranchiseAreaFilterProps {
  setArea: (area: { name: string; value: number[] | null }) => void;
  selectedArea: { name: string; value: number[] | null };
  isMyPub: boolean;
  setIsMyPub: (isMyPub: boolean) => void;
}

const FranchiseAreaFilter = ({
  setArea,
  selectedArea,
  isMyPub,
  setIsMyPub,
}: FranchiseAreaFilterProps) => {
  const inset = useRecoilValue(insetState);

  return (
    <FranchiseAreaFilterWrapper isApp={inset}>
      <Swiper
        className="filter-list"
        slidesPerView="auto"
        spaceBetween={6}
        freeMode={true}
        watchSlidesProgress={true}
        resistanceRatio={0}
      >
        <SwiperSlide>
          <img
            className="like-icon"
            src={
              isMyPub ? "/image-web/pub/like.svg" : "/image-web/pub/un-like.svg"
            }
            alt="arrow"
            onClick={() => setIsMyPub(!isMyPub)}
          />
        </SwiperSlide>

        {areaList.map((item, index) => (
          <SwiperSlide key={index}>
            <CardItemWrapper
              onClick={() => setArea(item)}
              isSelected={selectedArea.name === item.name}
            >
              {item.name.replace("러너펍", "").trim()}
            </CardItemWrapper>
          </SwiperSlide>
        ))}
      </Swiper>
    </FranchiseAreaFilterWrapper>
  );
};

export default FranchiseAreaFilter;
